import PropTypes from 'prop-types';
import styles from './FJFake3dPreviewItem.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import { useRef, useState } from 'react';
import classNames from 'classnames';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';

const FJFake3dPreviewItem = props => {
    const { data = {}, editPreset, width, height } = props;
    const { videoSrc } = data;
    const videoRef = useRef(null);
    const [stateIsEditLoading, setStateIsEditLoading] = useState(false);
    const _onPlay = () => {
        videoRef.current && videoRef.current.play();
    };
    const _onPause = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };
    const _edit = e => {
        e.stopPropagation();
        e.preventDefault();

        setStateIsEditLoading(true);
        editPreset(data, () => {
            setStateIsEditLoading(false);
        });
    };
    return (
        <div
            className={classNames(styles.box)}
            onMouseEnter={_onPlay}
            onMouseLeave={_onPause}
            style={{ width, height }}
        >
            <video className={styles.video} muted loop ref={videoRef} src={videoSrc} />
            {/* <div className={styles.btn} onClick={_edit}>
                {FJLocalStore._('have-a-try')}
            </div> */}
            <FJIconButton
                className={classNames(styles.use_this)}
                textClassName={styles.use_this_text}
                text={FJLocalStore._('have-a-try')}
                onClick={_edit}
                isLoading={stateIsEditLoading}
            />
        </div>
    );
};

FJFake3dPreviewItem.propTypes = {
    data: PropTypes.object,
    editPreset: PropTypes.func,
    width: PropTypes.number,
    height: PropTypes.number,
};
export default FJFake3dPreviewItem;
